function getTimeOfDay(): 'morning' | 'afternoon' | 'evening' {
  const h = new Date().getHours()
  if (h < 12) return 'morning'
  if (h < 17) return 'afternoon'
  return 'evening'
}

const GREETINGS = {
  morning: {
    eyebrow: 'Good morning',
    headline: 'Ready to help,',
    sub: 'What can I help you accomplish today?',
    chips: ["What can you help me with?", "What is win-win-win?", "What are the 3 screws to accelerate performance?", "Help me write a professional email"],
  },
  afternoon: {
    eyebrow: 'Good afternoon',
    headline: 'Good to see you,',
    sub: 'What would you like to work on this afternoon?',
    chips: ["What can you help me with?", "Summarise this text for me", "Help me plan my week", "What should I prioritise today?"],
  },
  evening: {
    eyebrow: 'Good evening',
    headline: 'Welcome back,',
    sub: "Let's get you sorted before you wrap up.",
    chips: ["What can you help me with?", "Review my day's work", "Help me draft a summary", "What were the key takeaways?"],
  },
}

interface WelcomeStateProps {
  userName?: string
  onChipClick: (text: string) => void
  chips?: string[]
}

export function WelcomeState({ userName = 'there', onChipClick, chips }: WelcomeStateProps) {
  const g = GREETINGS[getTimeOfDay()]
  // If chips is explicitly provided (even empty), do not fall back to defaults.
  // This allows routes like Playbooks to hide generic prompts when they have no starters.
  const chipList = chips != null ? chips : g.chips
  const chipsClassName = `chips-grid${chipList.length === 1 ? ' single' : ''}`

  return (
    <>
      <div className="welcome">
        <div className="greeting w-full">
          <div className="greet-eyebrow">{g.eyebrow}</div>
          <div className="greet-headline">
            {g.headline}
            <span className="greet-headline-name pb-2">{userName}?</span>
          </div>
          <div className="greet-sub">{g.sub}</div>
        </div>
        <div className={chipsClassName} role="list" aria-label="Suggested prompts">
          {chipList.map(chip => (
            <button
              key={chip}
              className="chip-card"
              onClick={() => onChipClick(chip)}
              role="listitem"
              aria-label={chip}
            >
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true" style={{ flexShrink: 0, marginTop: 1, color: 'var(--text-muted)' }}>
                <path d="M2 7h10M8 3l4 4-4 4" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <span>{chip}</span>
            </button>
          ))}
        </div>
      </div>
    </>
  )
}
